import { InjectionToken, makeStateKey } from '@angular/core';
import { type DynamicEnvironmentModel } from './models/dynamic-environment.model';

export const DYNAMIC_ENVIRONMENT = new InjectionToken<DynamicEnvironmentModel>('dynamic environment');
export const DYNAMIC_ENVIRONMENT_STATE_KEY = makeStateKey<DynamicEnvironmentModel>('DYNAMIC_ENVIRONMENT');
